import { aresManager } from '../manager';

const { ENV_ENUM, checkEnv, installEnvDep, curEnv } = aresManager.tools;

export {
  ENV_ENUM as env,
  checkEnv,
  installEnvDep,
  curEnv,
};
